import React from "react";
import PropTypes from "prop-types";

const LeasingAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 0L84 23.1V46.2V69.3L42 92.4L0 69.3V46.2V23.1L42 0Z"
        fill={fill}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="93"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84 23.1L42 0L0 23.1V36.75H84V23.1ZM84 69.3L42 92.4L0 69.3V55.65H84V69.3Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.35 26.9589V65.4411L42 84.7461L76.65 65.4411V26.9589L42 7.65393L7.35 26.9589ZM5.25 25.725V66.675L42 87.15L78.75 66.675V25.725L42 5.25L5.25 25.725Z"
          fill="white"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5004 28.7991V63.6009L42.0004 81.0736L73.5004 63.6009V28.7991L42.0004 11.3264L10.5004 28.7991ZM8.40039 27.5625V64.8375L42.0004 83.475L75.6004 64.8375V27.5625L42.0004 8.92499L8.40039 27.5625Z"
          fill="white"
        />
      </g>
      <path
        d="M14.6996 44.7013L10.1699 44.2901L8.39961 39.9L6.62931 44.2968L2.09961 44.7013L5.53941 47.838L4.50621 52.5L8.39961 50.0264L12.293 52.5L11.2661 47.838L14.6996 44.7013Z"
        fill="white"
      />
      <path
        d="M81.8998 44.7013L77.3701 44.2901L75.5998 39.9L73.8295 44.2968L69.2998 44.7013L72.7396 47.838L71.7064 52.5L75.5998 50.0264L79.4932 52.5L78.4663 47.838L81.8998 44.7013Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.475 28.35H26.25V65.1H41.475H56.7V28.35H41.475ZM35.7 31.5H30.45V46.2L35.7 41.6769L40.95 46.2V31.5H35.7ZM42 58.8H52.5V60.375H42V58.8ZM52.5 48.3H30.45V49.875H52.5V48.3ZM30.45 50.925H52.5V52.5H30.45V50.925ZM52.5 53.55H30.45V55.125H52.5V53.55Z"
        fill="white"
      />
    </svg>
  );
};

LeasingAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

LeasingAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default LeasingAwardIcon;
